import { PropsWithChildren } from 'react'
import clsx from 'clsx'

import Head from './Head'
import styles from './Page.module.scss'

type PageProps = PropsWithChildren<{
  title?: string
  description?: string
  className?: string
  imageId?: string | null
  noIndex?: boolean
  hideBrandName?: boolean
}>

function Page({
  title,
  description,
  children,
  imageId,
  className,
  noIndex = false,
  hideBrandName = false,
}: PageProps) {
  return (
    <>
      <Head
        title={title}
        description={description}
        imageId={imageId}
        noIndex={noIndex}
        hideBrandName={hideBrandName}
      />
      <main className={clsx(styles.mainContainer, className)}>{children}</main>
    </>
  )
}

export default Page

export type { PageProps }
